import React, { useState, useEffect } from "react";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Course.scss";

const Course = () => {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    const query = '*[_type == "certificates"]';

    client.fetch(query).then((data) => {
      setCertificates(data);
    });
  }, []);
  return (
    <>
      <h2 className="head-text">Certificados e Cursos</h2>

      <div className="app__course-container">
        {certificates.map((certificate, index) => (
          <section
            className="desktop-inner hover-coursemed certificate"
            key={index}
          >
            <div className="frame-parent">
              <div className="frame-child" />
              <div className="rectangle-shape">
                <img
                  className="text-info-icon"
                  src={urlFor(certificate.courseImage)}
                  alt={certificate.courseName}
                />
                <div className="u-x-experience">
                  <div className="ux-design hover-course">
                    {certificate.courseName}
                  </div>
                  <div className="por-udemy-em-container">
                    <span>Por </span>
                    <span className="organizacao hover-course">
                      {certificate.courseOrganization}
                    </span>
                    <b>{` `}</b>
                    <b>{` `}</b>
                    <span>
                      em{" "}
                      {new Date(certificate.courseEndDate).toLocaleDateString()}
                    </span>
                  </div>
                </div>
                <div className="ux-design-e hover-course">
                  {certificate.description}
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Course, "app__course"),
  "course",
  "app__whitebg"
);
